export default __webpack_public_path__ + "static/media/coin_icon.54ac3b49.svg";